export default "__VITE_ASSET__5l_hU4fQ__"